import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdminData } from './users/adminData.model';
import { Logs } from './log/logs.model';
import { SubscriptionModel } from '../subscription/subscription.model';
import { LogEvent } from './event/logEvent.model';
import { ApiResponse } from '../../models/base';

const ADMIN_ENDPOINT = '/admin';
const LIST_ENDPOINT = '/getUserList';
const LOG_ENDPOINT = '/getLogError';
const EVENT_ENDPOINT = '/getLogEvent';
const CHANGE_STATUS_ENDPOINT = '/changeUserStatus';
const CHANGE_EXPIRE_DATE_ENDPOINT = '/changeExpiryDateSubscription';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  userList: AdminData[] = [];
  logList: Logs[] = [];

  constructor(private http: HttpClient) {}

  GetUser(userUid: string): Promise<AdminData> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdminData>>(environment.apiUrl + ADMIN_ENDPOINT + '/getUser/' + userUid)
    ).then((response) => response.data);
  }

  GetUserList(): Promise<AdminData[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdminData[]>>(environment.apiUrl + LIST_ENDPOINT)
    ).then((response) => response.data);
  }

  GetSuscriptions(): Promise<SubscriptionModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<SubscriptionModel[]>>(environment.apiUrl + ADMIN_ENDPOINT + '/listsuscriptions')
    ).then((response) => response.data);
  }

  GetLogError(): Promise<Logs[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<Logs[]>>(environment.apiUrl + LOG_ENDPOINT)
    ).then((response) => response.data);
  }

  GetLogEvent(): Promise<LogEvent[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<LogEvent[]>>(environment.apiUrl + EVENT_ENDPOINT)
    ).then((response) => response.data);
  }

  ChangeUserStatus(data: AdminData): Promise<AdminData> {
    return firstValueFrom(
      this.http.post<ApiResponse<AdminData>>(environment.apiUrl + CHANGE_STATUS_ENDPOINT, data)
    ).then((response) => response.data);
  }

  ChangeUserData(data: AdminData): Promise<AdminData> {
    return firstValueFrom(
      this.http.post<ApiResponse<AdminData>>(environment.apiUrl + ADMIN_ENDPOINT + '/changeUserData', data)
    ).then((response) => response.data);
  }

  ChangeConsultant(data: AdminData): Promise<AdminData> {
    return firstValueFrom(
      this.http.post<ApiResponse<AdminData>>(environment.apiUrl + ADMIN_ENDPOINT + '/consultant', data)
    ).then((response) => response.data);
  }

  CleanEvents(): Promise<AdminData> {
    return firstValueFrom(
      this.http.get<ApiResponse<AdminData>>(environment.apiUrl + ADMIN_ENDPOINT + '/cleanEvents')
    ).then((response) => response.data);
  }

  public testNewVersion(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + ADMIN_ENDPOINT + '/testnewversion');
  }
}